/**
 * Equipment Rentals Route
 * Route configuration for the streamlined equipment rentals module
 */

import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const EquipmentRentals = lazy(() => import('./components/views/EquipmentRentalsView'));
const SessionLogPage = lazy(() => import('./sessions/SessionLogPage'));
const PartnerSettlementPage = lazy(() => import('./settlement/PartnerSettlementPage'));

const EquipmentRentalsRoute: FuseRouteItemType[] = [
	{
		path: '/equipment-rentals',
		children: [
			{ index: true, element: <EquipmentRentals /> },
			{ path: 'sessions', element: <SessionLogPage /> }
		]
	},
	{ path: '/partners/settlement', element: <PartnerSettlementPage /> }
];

export default EquipmentRentalsRoute;
